import { isValidUUID } from "@zapier/canvas-state";

export function isDraftNotTemplateNode(id: string) {
  return !isValidUUID(id) && !id.startsWith("_TEMPLATE_");
}
